<template>
  <div class="pi-game-vue">
    <div>
      <b-modal
        ref="modal"
        centered
        body-bg-variant=""
        body-text-variant="dark"
        no-close-on-backdrop
        hide-footer
        hide-header
      >
        <div class="text-center pt-5">
          <p>
            <label class="pb-3">
              <h2>
                {{
                  $lang(
                    "此活動只接收各政府部門人員報名,請問閣下是否屬政府部門之人員"
                  )
                }}
              </h2>
            </label>
          </p>
          <p>
            <b-button @click="back()">{{ $lang("BTN_YES") }}</b-button>
          </p>
        </div>
      </b-modal>
    </div>
    <h2
      class="competition-registration"
      style="border-bottom: 3px solid navy; color: navy; font-weight: bold"
    >
      {{ $lang("比賽項目") }}
    </h2>
    <div class="form">
      <div v-show="!loading">
        <b-form ref="form1" @submit="onSubmit">
          <!-- <div class="form-header">
            <div class="checkbox-group">
              <p>{{ $lang("健康聲明") }}</p>
              <ol>
                <li style="list-style-position: inside">
                  <span
                    >{{ $lang("所有參加者必須要提交健康聲明書") }}(<a
                      href=""
                      target="_blank"
                      >{{ $lang("按此下載範本") }}</a
                    >){{
                      $lang(
                        ".於2004-2008年出生的參加者必須提交經家長或者監護人填寫的健康聲明"
                      )
                    }}</span
                  >
                </li>
                <li style="list-style-position: inside">
                  {{ $lang("所有健康聲明可由澳門註冊醫生簽署的聲明書代簽") }}
                </li>
              </ol>
            </div>
          </div> -->
          <div class="form-header">
            <div class="checkbox-group">
              <p>{{ $lang("請選取下列合適選項") }}</p>
              <ul>
                <b-form-group>
                  <b-form-checkbox
                    name="healthCheck"
                    v-validate="{ required: true }"
                    :class="errors.has('healthCheck') && 'is-invalid'"
                    v-model="form.healthCheck"
                    :disabled="is_perview"
                  >
                    <span class="lbl">*{{ $lang("TEXT_ACCEPT_SELF") }}</span>
                  </b-form-checkbox>
                  <b-form-invalid-feedback :state="errors.has('healthCheck')">
                    {{ errors.first("healthCheck") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <!-- <b-form-group>
                  <b-form-checkbox
                    name="healthCheck2"
                    :class="errors.has('healthCheck2') && 'is-invalid'"
                    v-validate="{ required: true }"
                    v-model="form.healthCheck2"
                    :disabled="is_perview"
                  >
                   *<span class="lbl" v-html="$lang('TEXT_CHECK2')"></span>
                  </b-form-checkbox>
                  <b-form-invalid-feedback :state="errors.has('healthCheck2')">
                    {{ errors.first("healthCheck2") }}
                  </b-form-invalid-feedback>
                </b-form-group> -->
                <span style="color: navy; font-weight: bold"
                  >*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span
                >
              </ul>
            </div>
          </div>
          <div
            class="sportTable"
            v-for="sport in initData"
            :key="sport.title.zh_TW"
          >
            <div class="sport_title">
              {{
                $getLocale() === "zh-hant"
                  ? sport.title.zh_TW
                  : sport.title.pt_PT
              }}
              <span v-if="sport.tip.zh_TW" class="sport-tip"
                >（{{
                  $getLocale() === "zh-hant"
                    ? sport.tip.zh_TW
                    : sport.tip.pt_PT
                }}）</span
              >
              <a
                v-if="
                  $getLocale() === 'zh-hant' ? sport.url.zh_TW : sport.url.pt_PT
                "
                :href="
                  $getLocale() === 'zh-hant' ? sport.url.zh_TW : sport.url.pt_PT
                "
                style="color:navy;font-size:.8em"
                target="_blank"
                >{{ $lang("TEXT_PROJECT_CHARTER") }}</a
              >
            </div>
            <div class="sport_content">
              <ul class="m-0">
                <div
                  :key="item.title.zh_TW"
                  v-for="(item, index) in sport.child"
                >
                  <b-form-checkbox
                    v-if="!item.sub_child"
                    v-model="item.value"
                    :class="item.tip.zh_TW ? 'mt-3' : 'my-3'"
                    :disabled="is_perview || allowJoin"
                  >
                    <span
                      :class="item.tip.zh_TW ? 'sport-font' : 'sport-font mt-1'"
                    >
                      {{
                        $getLocale() === "zh-hant"
                          ? item.title.zh_TW
                          : item.title.pt_PT
                      }} </span
                    ><span v-if="!item.is_open" style="color:#dc3545"
                      >({{ $lang("人數少於成賽人數，故該項目無法成賽") }})</span
                    >
                  </b-form-checkbox>
                  <div v-else style="font-size: 1.1em;margin-top:10px">
                    <span
                      :class="item.tip.zh_TW ? 'sport-font' : 'sport-font mt-1'"
                    >
                      {{
                        $getLocale() === "zh-hant"
                          ? item.title.zh_TW
                          : item.title.pt_PT
                      }}
                    </span>
                  </div>

                  <span class="sport-tip">{{
                    $getLocale() === "zh-hant" ? item.tip.zh_TW : item.tip.pt_PT
                  }}</span>
                  <template v-if="item.value">
                    <template v-if="!item.sub_child">
                      <div class="row gamer-list" id="gamer-list-198" style="">
                        <div class="name mb-1">{{ $lang("FIELD_GAMER") }}</div>
                        <div class="gamer-group">
                          <table>
                            <tbody>
                              <tr class="th-width">
                                <th scope="col">
                                  {{ $lang("FIELD_NO_CHINESE_NAME") }}
                                </th>
                                <th scope="col">
                                  {{ $lang("FIELD_LAST_NAME") }}
                                </th>
                                <th scope="col">{{ $lang("FIELD_NAME") }}</th>
                                <!-- <th scope="col">
                                {{ $lang("FIELD_FIRST_NAME_OTHER") }}
                              </th>
                              <th scope="col">
                                {{ $lang("FIELD_LAST_NAME_OTHER") }}
                              </th> -->
                                <th scope="col">
                                  {{ $lang("FIELD_BIRTHDAY") }}
                                </th>
                                <th scope="col">{{ $lang("FIELD_GENDER") }}</th>
                                <th scope="col">
                                  {{ $lang("FIELD_ID_NUMBER_TYPE") }}
                                </th>
                                <th scope="col">
                                  {{ $lang("FIELD_ID_NUMBER") }}
                                </th>
                                <th scope="col">
                                  {{ $lang("FIELD_CLOSE_PHOTO") }}
                                </th>
                                <!-- <th scope="col"></th> -->
                              </tr>
                            </tbody>
                            <template>
                              <publicInstitutions-form
                                v-if="
                                  inputlist && Object.keys(inputlist).length > 0
                                "
                                :title="item.title"
                                :gender="item.gender"
                                :isOpen="item.is_open"
                                @updateValue="changeinput"
                                @reset="reset"
                                :sportTitle="sport.title.pt_PT"
                                :inputlist="inputlist"
                                :key="index + 1 + '..'"
                                :id="item.id"
                                :sportId="sport.id"
                                :indexs="index"
                                :canaddteam="item.canAddTeam"
                                :requiredType="requiredType"
                                :value="item.game"
                                :min="item.min_people"
                                :max="item.max_people"
                                :contact="item.require_team_contact"
                                :lead="item.require_team_lead"
                                :name="item.require_team_name"
                                :number="item.require_team_number"
                                :rules="isACaptain ? rulesA : rulesB"
                                ref="form-item"
                                :disabled="is_perview"
                              >
                              </publicInstitutions-form>
                            </template>
                          </table>
                          <div class="d-flex my-2">
                            <div v-if="item.canAddTeam" class="add-more mr-2">
                              <a
                                style="    white-space: nowrap"
                                @click="handleAdd(item)"
                                class="btn btn-success m-0"
                                href="javascript:void(0);"
                                data-id="198"
                                data-maxpeople="9999"
                                >+{{ $lang("增加參加隊伍") }}</a
                              >
                            </div>
                            <div
                              v-if="item.canAddTeam && item.game.length > 1"
                              class="add-more"
                            >
                              <a
                                @click="handleRemove(item, index)"
                                style="background: #fa8100; border: 1px solid; white-space: nowrap"
                                class="btn btn-success m-0"
                                href="javascript:void(0);"
                                data-id="198"
                                data-maxpeople="9999"
                                >+{{ $lang("刪除參加隊伍") }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        :key="items.title.zh_TW"
                        v-for="(items, indexs) in item.sub_child"
                      >
                        <b-form-checkbox
                          v-model="items.value"
                          style="    padding-left: 2rem;"
                          :class="items.tip.zh_TW ? 'mt-3 ' : 'my-3 '"
                          :disabled="is_perview || allowJoin"
                        >
                          <span
                            :class="
                              items.tip.zh_TW ? 'sport-font' : 'sport-font mt-1'
                            "
                          >
                            {{
                              $getLocale() === "zh-hant"
                                ? items.title.zh_TW
                                : items.title.pt_PT
                            }} </span
                          ><span v-if="!items.is_open" style="color:#dc3545"
                            >({{
                              $lang("人數少於成賽人數，故該項目無法成賽")
                            }})</span
                          >
                        </b-form-checkbox>
                        <span class="sport-tip">{{
                          $getLocale() === "zh-hant"
                            ? items.tip.zh_TW
                            : items.tip.pt_PT
                        }}</span>
                        <template v-if="items.value">
                          <div
                            class="row gamer-list"
                            id="gamer-list-198"
                            style=""
                          >
                            <div class="name mb-1">
                              {{ $lang("FIELD_GAMER") }}
                            </div>
                            <div class="gamer-group">
                              <table>
                                <tbody>
                                  <tr class="th-width">
                                    <th scope="col">
                                      {{ $lang("FIELD_NO_CHINESE_NAME") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_LAST_NAME") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_NAME") }}
                                    </th>
                                    <!-- <th scope="col">
                                {{ $lang("FIELD_FIRST_NAME_OTHER") }}
                              </th>
                              <th scope="col">
                                {{ $lang("FIELD_LAST_NAME_OTHER") }}
                              </th> -->
                                    <th scope="col">
                                      {{ $lang("FIELD_BIRTHDAY") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_GENDER") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_ID_NUMBER_TYPE") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_ID_NUMBER") }}
                                    </th>
                                    <th scope="col">
                                      {{ $lang("FIELD_CLOSE_PHOTO") }}
                                    </th>
                                    <!-- <th scope="col"></th> -->
                                  </tr>
                                </tbody>
                                <template>
                                  <publicInstitutions-form
                                    v-if="
                                      inputlist &&
                                        Object.keys(inputlist).length > 0
                                    "
                                    :title="items.title"
                                    :isOpen="items.is_open"
                                     :gender="items.gender"
                                      :sportTitle="sport.title.pt_PT"
                                    @updateValue="changeinput"
                                    @reset="reset"
                                    :inputlist="inputlist"
                                    :subchild="true"
                                    :key="index + 1 + '..'"
                                    :subchildindexs="indexs"
                                    :id="items.id"
                                    :sportId="sport.id"
                                    :indexs="index"
                                    :canaddteam="items.canAddTeam"
                                    :requiredType="requiredType"
                                    :value="items.game"
                                    :min="items.min_people"
                                    :max="items.max_people"
                                    :contact="items.require_team_contact"
                                    :lead="items.require_team_lead"
                                    :name="items.require_team_name"
                                    :rules="isACaptain ? rulesA : rulesB"
                                    ref="form-item"
                                    :disabled="is_perview"
                                  >
                                  </publicInstitutions-form>
                                </template>
                              </table>
                              <div class="d-flex my-2">
                                <div
                                  v-if="items.canAddTeam"
                                  class="add-more mr-2"
                                >
                                  <a
                                    style="    white-space: nowrap"
                                    @click="handleAdd(items, true, indexs)"
                                    class="btn btn-success m-0"
                                    href="javascript:void(0);"
                                    data-id="198"
                                    data-maxpeople="9999"
                                    >+{{ $lang("增加參加隊伍") }}</a
                                  >
                                </div>
                                <div
                                  v-if="
                                    items.canAddTeam && items.game.length > 1
                                  "
                                  class="add-more"
                                >
                                  <a
                                    @click="handleRemove(items, indexs,true)"
                                    style="background: #fa8100; border: 1px solid; white-space: nowrap"
                                    class="btn btn-success m-0"
                                    href="javascript:void(0);"
                                    data-id="198"
                                    data-maxpeople="9999"
                                    >+{{ $lang("刪除參加隊伍") }}</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </template>
                </div>
              </ul>
            </div>
          </div>
          <!-- <b-form-group>
            <b-form-checkbox
              name="allowSMS"
              v-validate="{ required: false }"
              :class="errors.has('allowSMS') && 'is-invalid'"
              v-model="form.allowSMS"
              :disabled="is_perview"
            >
              <span class="lbl">*{{ $lang("接受賽事SMS及電郵") }}</span>
            </b-form-checkbox>
            <b-form-invalid-feedback :state="errors.has('allowSMS')">
              {{ errors.first("allowSMS") }}
            </b-form-invalid-feedback>
          </b-form-group> -->
          <div class="form-footer">
            <div>
              <template v-if="!is_perview">
                <!-- <b-btn
                  v-if="form.teamMembers.length < 10"
                  variant="success btn-round"
                  @click.prevent="handleAdd"
                  >+{{ $lang("添加參賽者") }}</b-btn
                > -->
                <button
                  style="
                    background: linear-gradient(to right, #f36725, #f7b12b);
                  "
                  type="submit"
                  class="btn btn-primary btn-submit save"
                  @click="save"
                  :disabled="isDisable"
                >
                  {{ $lang("TITLE_APPROVAL_GAME_INFO") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary btn-submit save"
                  @click="submitForm"
                  :disabled="isDisable"
                >
                  {{ $lang("TEXT_SAVE") }}
                </button>
              </template>
              <!-- <p>
                {{ $lang("TITLE_FORM_TIP") }}
              </p> -->
              <p>
                {{
                  $lang(
                    "若違反本章程出賽之參賽者，將被取消比賽資格，而違規隊伍於該場賽事亦作棄權處理"
                  )
                }}
              </p>
              <p>
                {{ $lang("報名表一經遞交，即視為同意本章程及所有規則") }}
              </p>
              <p>
                {{
                  $lang(
                    "所收集的個人資料會用作體育活動報名之用並記載於資料庫內。有關資料將傳送予協辦活動之體育總會。根據第8/2005號法律，資料當事人有權查閱、更正及更新其在體育局儲存的個人資料。所有個人資料會絕對保密及確保安全"
                  )
                }}
              </p>
            </div>
          </div>
        </b-form>
      </div>
      <div class="spinner" v-show="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import PublicInstitutionsForm from "./components/index.vue";
import moment from "moment";
import { ValidationObserver } from "vee-validate";

export default {
  props: {
    isTeam: { type: Boolean },
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    PublicInstitutionsForm,
    ValidationObserver,
  },
  data() {
    return {
      allowJoin: true,
      perview: [],
      inputlist: [],
      index: 0,
      loading: false,
      indexs: 0,
      requiredType: false,
      status: "",
      isDisable: false,
      // selected: "individual",
      isIdentity: true,
      // participateDate: [],
      rulesA: {
        birth: {
          women_carnival_a: [1981, 2003],
        },
        // idNumber: {
        //     idNumber: true
        // }
        mobile: {
          mobile: true,
          required: true,
        },
      },
      rulesB: {
        birth: {
          women_carnival_b: [1961, 1980],
        },
        mobile: {
          mobile: true,
          required: true,
        },
        // idNumber: {
        //     idNumber: true
        // }
      },
      initData: [],
      form: {
        piGameId: null,
        healthCheckFile: "",
        healthCheck: null,
        healthCheck2: true,
      },
    };
  },
  methods: {
    reset(
      Idnumber,
      childIndex,
      Index,
      id,
      sportId,
      lastIndex,
      s,
      subchild,
      subindex
    ) {
      console.log(subindex, subchild);
      if (subchild) {
        if (this.initData[sportId].child[Index].sub_child) {
          setTimeout(() => {
            this.$set(
              this.initData[sportId].child[Index].sub_child[subindex].game[
                lastIndex
              ].gamer,
              childIndex,
              {
                noChineseName: false,
                mobile: "",
                number: "",
                email: "",
                lastNameOther: "",
                firstNameOther: "",
                lastName: "",
                firstName: "",
                birthday: "",
                gender: "",
                idNumber: "",
                pic: "",
                idType: "",
                disabled: false,
              }
            );
          }, 50);
        }
      } else {
        setTimeout(() => {
          this.$set(
            this.initData[sportId].child[Index].game[lastIndex].gamer,
            childIndex,
            {
              noChineseName: false,
              mobile: "",
              number: "",
         
              email: "",
              lastNameOther: "",
              firstNameOther: "",
              lastName: "",
              firstName: "",
              birthday: "",
              gender: "",
              idNumber: "",
              pic: "",
              idType: "",
              disabled: false,
            }
          );
        }, 50);
      }
    },
    changeinput(
      Idnumber,
      childIndex,
      Index,
      id,
      sportId,
      lastIndex,
      checkobx,
      subchild,
      subindex
    ) {
      // console.log(Idnumber, childIndex, Index, id, sportId, lastIndex);
      // console.log(
      //   this.initData[sportId].child[Index].game[lastIndex].gamer[childIndex]
      // );
      console.log(this.inputlist);
      console.log(subchild, subindex, lastIndex, childIndex);
      if (subchild) {
        Object.keys(this.inputlist).forEach((item) => {
          console.log(item);
          if (this.inputlist[item].idNumber == Idnumber) {
            setTimeout(() => {
              this.$set(
                this.initData[sportId].child[Index].sub_child[subindex].game[
                  lastIndex
                ].gamer,
                childIndex,
                {
                  ...JSON.parse(JSON.stringify(this.inputlist[item])),
                }
              );
            }, 50);
            setTimeout(() => {
              this.$set(
                this.initData[sportId].child[Index].sub_child[subindex].game[
                  lastIndex
                ].gamer[childIndex],
                "disabled",
                true
              );
            }, 100);
            console.log(this.inputlist[item]);
            // console.log(321);
          }
        });
      } else {
        Object.keys(this.inputlist).forEach((item) => {
          if (this.inputlist[item].idNumber == Idnumber) {
            setTimeout(() => {
              this.$set(
                this.initData[sportId].child[Index].game[lastIndex].gamer,
                childIndex,
                {
                  ...JSON.parse(JSON.stringify(this.inputlist[item])),
                }
              );
            }, 50);
            setTimeout(() => {
              this.$set(
                this.initData[sportId].child[Index].game[lastIndex].gamer[
                  childIndex
                ],
                "disabled",
                true
              );
            }, 100);
            console.log(
              Idnumber,
              this.initData[sportId].child[Index].game[lastIndex].gamer,
              this.inputlist[item]
            );
            // console.log(this.initData);
            // console.log(321);
          }
        });
      }
    },
    save() {
      this.requiredType = true;
      this.status = "draft";
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.$validator.validateAll().then((validate) => {
        console.log(validate);
        if (validate) {
          if (this.$refs["form-item"]) {
            console.log(this.$refs["form-item"]);
            var promise_list = this.$refs["form-item"].map((item) => {
              return item.onSubmit();
            });
            Promise.all(promise_list).then((list) => {
              console.log(list);

              var result = list.every((item) => item);
              if (result) {
                let game = [];
                console.log(this.initData);
                Object.keys(this.initData).forEach((item) => {
                  this.initData[item].child.forEach((items) => {
                    items.game.forEach((itemss) => {
                      if (items.value) {
                        if (items.sub_child) {
                          items.sub_child.forEach((child) => {
                            console.log(child);
                            if (child.value) {
                              child.game.forEach((c_item) => {
                                c_item.gamer.forEach((i) => {
                                  i.birthday =
                                    this.$changeTime(i.birthday) || null;
                                });

                                delete c_item["index"];
                                delete c_item["disabled"];
                                game.push(c_item);
                              });
                            }
                          });
                        } else {
                          itemss.gamer.forEach((i) => {
                            i.birthday = this.$changeTime(i.birthday) || null;
                          });

                          delete itemss["index"];
                          delete itemss["disabled"];
                          game.push(itemss);
                        }
                      }
                    });
                  });
                });
                var form = {
                  ...this.form,
                  // status: this.status,
                  game: game,
                };
                console.log(form);
                if (this.status === "draft") {
                  if (this.$refs["form-item"]) {
                    if (this.form.healthCheck && this.form.healthCheck2) {
                      this.recordUpdate(form);
                      this.errorScoll();
                    } else {
                      this.notification.warning(this.$lang("TEXT_WARNING_3"));
                    }

                    //   this.$validator.validateAll();
                    // console.log(this.$refs["form-item"]);
                    // var promise_list = await this.$refs["form-item"].map((item) =>
                    //   item.onSubmit()
                    // );
                    // this.$validator.validateAll("form1").then((validate) => {
                    //   Promise.all(promise_list).then((list) => {
                    //     var result = list.every((item) => item);
                    //     this.errorScoll();

                    //     if (result) {
                    //       if (
                    //         this.form.healthCheckFile &&
                    //         this.form.healthCheck2 &&
                    //         this.form.healthCheck2
                    //       ) {
                    //         this.recordUpdate(form);
                    //       } else {
                    //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
                    //       }
                    //     } else {
                    //       this.errorScoll();
                    //     }
                    //   });
                    // });
                  } else {
                    this.notification.warning(this.$lang("未選擇項目"));
                  }
                } else {
                  if (this.$refs["form-item"]) {
                    if (this.form.healthCheck && this.form.healthCheck2) {
                      this.recordUpdate(form);
                      this.errorScoll();
                    } else {
                      this.notification.warning(this.$lang("TEXT_WARNING_3"));
                    }

                    //   this.$validator.validateAll();
                    // console.log(this.$refs["form-item"]);
                    // var promise_list = await this.$refs["form-item"].map((item) =>
                    //   item.onSubmit()
                    // );
                    // this.$validator.validateAll("form1").then((validate) => {
                    //   Promise.all(promise_list).then((list) => {
                    //     var result = list.every((item) => item);
                    //     this.errorScoll();

                    //     if (result) {
                    //       if (
                    //         this.form.healthCheckFile &&
                    //         this.form.healthCheck2 &&
                    //         this.form.healthCheck2
                    //       ) {
                    //         this.recordUpdate(form);
                    //       } else {
                    //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
                    //       }
                    //     } else {
                    //       this.errorScoll();
                    //     }
                    //   });
                    // });
                  } else {
                    this.notification.warning(this.$lang("未選擇項目"));
                  }
                }
              } else {
                this.errorScoll();
              }
              // console.log(result);
            });
          } else {
            this.notification.warning(this.$lang("未選擇項目"));
          }
        } else {
          this.errorScoll();
        }
      });
    },
    // 防止連續點擊重複提交
    PreventDuplicateSubmit() {
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },

    handleRemove(slug,index,subchild) {
      // console.log( slug);
      if (subchild) {
        Object.keys(this.initData).forEach((key) => {
          this.initData[key].child.forEach((items) => {
            if (items.sub_child) {
              items.sub_child.forEach((item) => {
                if (item.id === slug.id) {
                  console.log(item.game.length - 1);
                  item.game.splice(item.game.length - 1, 1);
                }
              });
            }
          });
        });
      } else {
        Object.keys(this.initData).forEach((key) => {
          this.initData[key].child.forEach((item) => {
            if (item.id === slug.id) {
              console.log(item.game.length - 1);
              item.game.splice(item.game.length - 1, 1);
            }
          });
        });
      }
    },
    handleAdd(slug, subchild, index) {
      if (subchild) {
        this.indexs++;
        Object.keys(this.initData).forEach((key) => {
          this.initData[key].child.forEach((items) => {
            if (items.sub_child) {
              items.sub_child.forEach((item) => {
                let gamers = [];
                if (item.min_people) {
                  for (let index = 0; index < item.min_people; index++) {
                    gamers.push({
                      noChineseName: false,
                      mobile: "",
                      number: "",
                    
                      email: "",
                      lastNameOther: "",
                      firstNameOther: "",
                      lastName: "",
                      firstName: "",
                      birthday: "",
                      gender: "",
                      idNumber: "",
                      pic: "",
                      idType: "",
                      disabled: false,
                    });
                  }
                } else {
                  gamers = [
                    {
                      noChineseName: false,
                      mobile: "",
                      number: "",
                   
                      email: "",
                      lastNameOther: "",
                      firstNameOther: "",
                      lastName: "",
                      firstName: "",
                      birthday: "",
                      gender: "",
                      idNumber: "",
                      idType: "",
                      pic: "",
                      disabled: false,
                    },
                  ];
                }
                if (item.id === slug.id) {
                  if (item.canAddTeam) {
                    item.game.push({
                      index: this.index,
                      teamName: "",
                      teamNameOther: "", 
                      color:'',
                      contact: {
                        name: "",
                        phone: "",
                      },
                      lead: {
                        name: "",
                        phone: "",
                      },
                      gameId: item.id,
                      gamer: gamers,
                    });
                  } else {
                    item.game.push({
                      index: this.index,
                      gameId: item.id,
                      gamer: gamers,
                    });
                  }
                }
              });
            }
          });
        });
      } else {
        this.index++;
        Object.keys(this.initData).forEach((key) => {
          this.initData[key].child.forEach((item) => {
            let gamers = [];
            if (item.min_people) {
              for (let index = 0; index < item.min_people; index++) {
                gamers.push({
                  noChineseName: false,
                  mobile: "",
                  number: "",
              
                  email: "",
                  lastNameOther: "",
                  firstNameOther: "",
                  lastName: "",
                  firstName: "",
                  birthday: "",
                  gender: "",
                  idNumber: "",
                  pic: "",
                  idType: "",
                  disabled: false,
                });
              }
            } else {
              gamers = [
                {
                  noChineseName: false,
                  mobile: "",
                  number: "",
               
                  email: "",
                  lastNameOther: "",
                  firstNameOther: "",
                  lastName: "",
                  firstName: "",
                  birthday: "",
                  gender: "",
                  idNumber: "",
                  idType: "",
                  pic: "",
                  disabled: false,
                },
              ];
            }
            if (item.id === slug.id) {
              if (item.canAddTeam) {
                item.game.push({
                  index: this.index,
                  teamName: "",
                  teamNameOther: "",
                  color:'',
                  contact: {
                    name: "",
                    phone: "",
                  },
                  lead: {
                    name: "",
                    phone: "",
                  },
                  gameId: item.id,
                  gamer: gamers,
                });
              } else {
                item.game.push({
                  index: this.index,
                  gameId: item.id,
                  gamer: gamers,
                });
              }
              // console.log(item);
            }
          });
        });
      }
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        item.bornAt = this.$changeTime(item.bornAt) || null;
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.recordPro(form)
          .then((resp) => {
            if (resp.code === 0) {
              window.location.href =
                window.location.origin + this.perview["perview-url"];
            } else {
              if (typeof err.message == "string") {
                this.notification.error(this.$lang(err.message));
              } else {
                this.$refs["form-item"].forEach((item) => {
                  let id = item.getSportId();
                  // console.log(index,id,123);
                  Object.keys(err.message).forEach((i) => {
                    // console.log(id,);
                    if (id === Number(i)) {
                      item.getError(err.message[i]);
                    }
                  });
                });
                // Object.keys(err.message).forEach((element) => {
                //   //  console.log(Object.keys(err.message[element]));
                //   if (Object.keys(err.message[element]).length > 1) {
                //     // console.log(err.message[element]);
                //     Object.keys(err.message[element]).forEach((item) => {
                //       this.notification.error(
                //         this.$lang(err.message[element][item])
                //       );
                //     });
                //   } else {
                //     this.notification.error(this.$lang(err.message[element]));
                //   }
                // });
              }
            }
          })
          .catch((err) => {
            if (typeof err.message == "string") {
              this.notification.error(this.$lang(err.message));
            } else {
              this.$refs["form-item"].forEach((item) => {
                let id = item.getSportId();
                // console.log(index,id,123);
                Object.keys(err.message).forEach((i) => {
                  // console.log(id,);
                  if (id === Number(i)) {
                    item.getError(err.message[i]);
                  }
                });
              });
              // Object.keys(err.message).forEach((element) => {
              //   //  console.log(Object.keys(err.message[element]));
              //   if (Object.keys(err.message[element]).length > 1) {
              //     // console.log(err.message[element]);
              //     Object.keys(err.message[element]).forEach((item) => {
              //       this.notification.error(
              //         this.$lang(err.message[element][item])
              //       );
              //     });
              //   } else {
              //     this.notification.error(this.$lang(err.message[element]));
              //   }
              // });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("提交成功"));
            // } else {
            //     this.notification.success(this.$lang("提交成功"));
            // }
            if (resp.code === 0) {
              this.notification.success(this.$lang("提交成功"));
              // setTimeout(() => {
              //   window.location.href =
              //     window.location.origin + this.perview.url;
              // }, 1000);
            } else {
              if (typeof err.message == "string") {
                this.notification.error(this.$lang(err.message));
              } else {
                this.$refs["form-item"].forEach((item) => {
                  let id = item.getSportId();
                  // console.log(index,id,123);
                  Object.keys(err.message).forEach((i) => {
                    // console.log(id,);
                    if (id === Number(i)) {
                      item.getError(err.message[i]);
                    }
                  });
                });
                // Object.keys(err.message).forEach((element) => {
                //   //  console.log(Object.keys(err.message[element]));
                //   if (Object.keys(err.message[element]).length > 1) {
                //     // console.log(err.message[element]);
                //     Object.keys(err.message[element]).forEach((item) => {
                //       this.notification.error(
                //         this.$lang(err.message[element][item])
                //       );
                //     });
                //   } else {
                //     this.notification.error(this.$lang(err.message[element]));
                //   }
                // });
              }

              this.errorScoll();
            }
          })
          .catch((err) => {
            if (typeof err.message == "string") {
              this.notification.error(this.$lang(err.message));
            } else {
              this.$refs["form-item"].forEach((item) => {
                let id = item.getSportId();
                // console.log(index,id,123);
                Object.keys(err.message).forEach((i) => {
                  // console.log(id,);
                  if (id === Number(i)) {
                    item.getError(err.message[i]);
                  }
                });
              });
              // Object.keys(err.message).forEach((element) => {
              //   //  console.log(Object.keys(err.message[element]));
              //   if (Object.keys(err.message[element]).length > 1) {
              //     // console.log(err.message[element]);
              //     Object.keys(err.message[element]).forEach((item) => {
              //       this.notification.error(
              //         this.$lang(err.message[element][item])
              //       );
              //     });
              //   } else {
              //     this.notification.error(this.$lang(err.message[element]));
              //   }
              // });
            }
            this.errorScoll();
            // if (err.data.groupName) {
            //   this.errors.add({
            //     field: err.data.groupName.path,
            //     msg: err.data.groupName.message,
            //   });
            //   this.notification.error(this.$lang(err.data.groupName.message));
            // }
            // if (err.data.teamName) {
            //   this.errors.add({
            //     field: err.data.teamName.path,
            //     msg: err.data.teamName.message,
            //   });
            //   this.notification.error(this.$lang(err.data.teamName.message));
            // }
            // if (err.data.teamCaptain) {
            //   this.errors.add({
            //     field: err.data.teamCaptain.path,
            //     msg: err.data.teamCaptain.message,
            //   });
            //   this.notification.error(this.$lang(err.data.teamCaptain.message));
            // }
            // if (err.data.teamMembers) {
            //   if (err.data.teamMembers instanceof Array) {
            //     err.data.teamMembers.forEach((item, index) => {
            //       this.$refs["form-item"][index].validateErrors(
            //         item.path,
            //         this.$lang(item.message)
            //       );
            //       this.notification.error(this.$lang(item.message));
            //     });
            //   } else {
            //     if (err.data.length == 0) {
            //       this.notification.error(this.$lang(err.message));
            //     }
            //     var teamMembers = err.data.teamMembers;
            //     var that = this;
            //     Object.keys(teamMembers).forEach(function (key) {
            //       that.$refs["form-item"][key].validateErrors(
            //         teamMembers[key].path,
            //         that.$lang(teamMembers[key].message)
            //       );
            //       that.notification.error(that.$lang(teamMembers[key].message));
            //     });
            //     // var errs = err.data.teamMembers;
            //     // var that = this;
            //     // Object.keys(errs).forEach(function (key) {
            //     //     that.notification.error(that.$lang(errs[key].message));
            //     // });
            //   }
            // }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    async recordPro(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.pbulicInstitution
          .save(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getGame() {
      console.log(this.$i18n.locale);
      $apis.pbulicInstitution
        .get_game()
        .then((resp) => {
          if (resp.code === 0) {
            this.initData = resp.data;
            Object.keys(this.initData).forEach((key) => {
              this.initData[key].child.forEach((item) => {
                let gamers = [];
                if (item.min_people) {
                  for (let index = 0; index < item.min_people; index++) {
                    gamers.push({
                      noChineseName: false,
                      mobile: "",
                      number: "",
                 
                      email: "",
                      lastNameOther: "",
                      firstNameOther: "",
                      lastName: "",
                      firstName: "",
                      birthday: "",
                      gender: "",
                      idType: "",
                      idNumber: "",
                      pic: "",
                      disabled: false,
                    });
                  }
                } else {
                  if (item.sub_child) {
                    item.sub_child.forEach((items) => {
                      let childgamers = [];
                      if (items.min_people) {
                        for (
                          let indexs = 0;
                          indexs < items.min_people;
                          indexs++
                        ) {
                          childgamers.push({
                            noChineseName: false,
                            mobile: "",
                            number: "",
                        
                            email: "",
                            lastNameOther: "",
                            firstNameOther: "",
                            lastName: "",
                            firstName: "",
                            birthday: "",
                            gender: "",
                            idType: "",
                            idNumber: "",
                            pic: "",
                            disabled: false,
                          });
                        }
                      } else {
                        childgamers = [
                          {
                            noChineseName: false,
                            mobile: "",
                            number: "",
                         
                            email: "",
                            lastNameOther: "",
                            firstNameOther: "",
                            lastName: "",
                            firstName: "",
                            birthday: "",
                            idType: "",
                            gender: "",
                            idNumber: "",
                            pic: "",
                            disabled: false,
                          },
                        ];
                      }
                      this.$set(items, "value", false);
                      if (items.canAddTeam) {
                        //組隊
                        this.$set(items, "game", [
                          {
                            index: 0,
                            teamName: "",
                            teamNameOther: "",
                            color:'',
                            contact: {
                              name: "",
                              phone: "",
                            },
                            lead: {
                              name: "",
                              phone: "",
                            },
                            gameId: items.id,
                            gamer: childgamers,
                          },
                        ]);
                      } else {
                        //單人
                        this.$set(items, "game", [
                          {
                            index: 0,
                            gameId: items.id,
                            gamer: childgamers,
                          },
                        ]);
                      }
                    });
                  } else {
                    gamers = [
                      {
                        noChineseName: false,
                        mobile: "",
                        number: "",
                      
                        email: "",
                        lastNameOther: "",
                        firstNameOther: "",
                        lastName: "",
                        firstName: "",
                        birthday: "",
                        idType: "",
                        gender: "",
                        idNumber: "",
                        pic: "",
                        disabled: false,
                      },
                    ];
                  }
                }
                if (item.sub_child) {
                  this.$set(item, "value", true);
                } else {
                  this.$set(item, "value", false);
                }

                if (item.canAddTeam) {
                  //組隊
                  this.$set(item, "game", [
                    {
                      index: 0,
                      teamName: "",
                      teamNameOther: "",
                       color:'',
                      contact: {
                        name: "",
                        phone: "",
                      },
                      lead: {
                        name: "",
                        phone: "",
                      },
                      gameId: item.id,
                      gamer: gamers,
                    },
                  ]);
                } else {
                  //單人
                  this.$set(item, "game", [
                    {
                      index: 0,
                      gameId: item.id,
                      gamer: gamers,
                    },
                  ]);
                }
              });
            });
            var id = this.$route.params.id;
            var isNew = this.is_new;
            this.form.piGameId = id;
            id && this.recordDetail(id);
            isNew && this.getUserInfo();
            // console.log(this.initData);
          } else {
          }
        })
        .catch((err) => {});
    },
    // save
    async recordDetail(id) {
      this.loading = true;
      $apis.pbulicInstitution
        .get_team_info({ id })
        .then((resp) => {
          console.log(resp.code);
          if (resp.code === 0) {
            console.log(resp.data);
            this.inputlist = resp.data;

            if (Object.keys(this.inputlist).length > 0) {
              this.allowJoin = false;
            } else {
              this.allowJoin = true;
            }
            $apis.pbulicInstitution
              .get_perview({
                id,
              })
              .then((perview) => {
                this.perview = perview.data;
                this.loading = false;
                if (this.perview.game.length > 0) {
                  this.form.healthCheck = true;
                  this.form.healthCheck2 = true;
                  this.form.healthCheckFile = this.perview.healthCheckFile;
                  if (this.initData) {
                    // console.log(this.perview.game,123321);
                    // console.log(this.initData);
                    this.perview.game.forEach((i) => {
                      // console.log(i.gameId);
                      Object.keys(this.initData).forEach((key) => {
                        this.initData[key].child.forEach((item) => {
                          // console.log(item);
                          if (item.sub_child) {
                            item.value = true;
                            item.sub_child.forEach((sub) => {
                              if (i.gameId === sub.id) {
                                sub.value = true;
                                // console.log(i);
                                i.gamer.forEach((s) => {
                                  this.$set(s, "disabled", true);
                                });
                                sub.game.push(i);
                              }
                            });
                          } else {
                            if (i.gameId === item.id) {
                              item.value = true;
                              // console.log(i);
                              i.gamer.forEach((s) => {
                                this.$set(s, "disabled", true);
                              });
                              item.game.push(i);
                            }
                          }
                        });
                      });
                    });

                    Object.keys(this.initData).forEach((key) => {
                      this.initData[key].child.forEach((item) => {
                        if (item.sub_child) {
                          item.sub_child.forEach((sub) => {
                            if (item.value && sub.value) {
                              sub.game.splice(0, 1);
                            }
                          });
                        } else {
                          if (item.value) {
                            item.game.splice(0, 1);
                          }
                        }
                      });
                    });
                    Object.keys(this.initData).forEach((key) => {
                      this.initData[key].child.forEach((item) => {
                        if (item.sub_child) {
                          item.sub_child.forEach((sub) => {
                            if (item.value && sub.value) {
                              if (sub.min_people == null) {
                                // console.log(item.min_people, 123);
                                // console.log(item, "item");
                                sub.game.forEach((items) => {
                                  if (items.gamer.length == 0) {
                                    items.gamer.push({
                                      noChineseName: false,
                                      mobile: "",
                                      number: "",
                                    
                                      email: "",
                                      lastNameOther: "",
                                      firstNameOther: "",
                                      lastName: "",
                                      firstName: "",
                                      birthday: "",
                                      gender: "",
                                      idType: "",
                                      idNumber: "",
                                      pic: "",
                                    });
                                  }
                                });
                              } else {
                                sub.game.forEach((items) => {
                                  console.log(
                                    item.min_people - items.gamer.length
                                  );
                                  for (
                                    let index = 0;
                                    index < sub.min_people - items.gamer.length;
                                    index++
                                  ) {
                                    items.gamer.push({
                                      noChineseName: false,
                                      mobile: "",
                                      number: "",
                                    
                                      email: "",
                                      lastNameOther: "",
                                      firstNameOther: "",
                                      lastName: "",
                                      firstName: "",
                                      birthday: "",
                                      gender: "",
                                      idType: "",
                                      idNumber: "",
                                      pic: "",
                                    });
                                  }
                                });
                              }
                            }
                          });
                        } else {
                          if (item.value) {
                            if (item.min_people == null) {
                              // console.log(item.min_people, 123);
                              // console.log(item, "item");
                              item.game.forEach((items) => {
                                if (items.gamer.length == 0) {
                                  items.gamer.push({
                                    noChineseName: false,
                                    mobile: "",
                                    number: "",
                             
                                    email: "",
                                    lastNameOther: "",
                                    firstNameOther: "",
                                    lastName: "",
                                    firstName: "",
                                    birthday: "",
                                    gender: "",
                                    idType: "",
                                    idNumber: "",
                                    pic: "",
                                  });
                                }
                              });
                            } else {
                              item.game.forEach((items) => {
                                console.log(
                                  item.min_people - items.gamer.length
                                );
                                for (
                                  let index = 0;
                                  index < item.min_people - items.gamer.length;
                                  index++
                                ) {
                                  items.gamer.push({
                                    noChineseName: false,
                                    mobile: "",
                                    number: "",
                             
                                    email: "",
                                    lastNameOther: "",
                                    firstNameOther: "",
                                    lastName: "",
                                    firstName: "",
                                    birthday: "",
                                    gender: "",
                                    idType: "",
                                    idNumber: "",
                                    pic: "",
                                  });
                                }
                              });
                            }
                          }
                        }
                      });
                    });
                  }
                }
              });
            console.log(this.initData);
          } else {
            this.notification.error(resp.message);
          }
        })
        .catch((err) => {
          this.notification.error(err.message);
        });
      console.log(this.initData, 123);
      // console.log(this.initData, 1);
      // this.form = resp.data;
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          //   var data = resp.data;
          //   if (this.$route.params.locale == "zh-hant") {
          //     this.form.teamCaptain.name = data.firstNameZh + data.lastNameZh;
          //   } else {
          //     this.form.teamCaptain.name = data.firstNamePt + data.lastNamePt;
          //   }
          //   this.form.teamMembers[0].name = this.form.teamCaptain.name; //也默认
          //   // this.form.teamCaptain.bornAt = data.bornAt;
          //   // this.form.teamCaptain.idType = data.idType;
          //   // this.form.teamCaptain.idNumber = data.idNumber;
          //   this.form.teamCaptain.phone = data.contact[data.contact.length - 1];
          //   this.form.teamCaptain.email = data.email ? data.email : "";
          // this.form.teamCaptain.fax = '';
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    publicInstitutions_games() {
      return this.$store.state.base.publicInstitutions_games;
    },
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/springFestivalCycleHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
    isACaptain() {
      // var value = this.form.teamCaptain.bornAt;
      // if (!value) return false;
      // var year = new Date(value).getFullYear();
      // let result = year >= 1981 && year <= 2003;
      // if (!result) {
      //     this.form.isAgree1 = null;
      // }
      return this.form.groupType === "A";
    },
    curYear() {
      return moment().format("YYYY");
    },
  },
  created() {
    this.getGame();
  },

  // watch: {
  //     "form.teamCaptain.idType": {
  //         handler(n) {
  //             if (n == "1") {
  //                 this.isIdentity = true;
  //             } else {
  //                 this.isIdentity = false;
  //             }
  //         },
  //         immediate: true
  //     }
  // }
};
</script>
<style lang="scss">
.form-row{
  align-items: center;
}
.th-width {
  th:nth-child(1) {
    width: 9%;
  }
  th:nth-child(2) {
    width: 14%;
  }
  th:nth-child(3) {
    width: 14%;
  }

  th:nth-child(4) {
    width: 15%;
  }
  th:nth-child(5) {
    width: 10%;
  }
  th:nth-child(6) {
    width: 15%;
  }
  th:nth-child(7) {
    width: 12%;
  }
  th:nth-child(8) {
    width: 10.9%;
  }
}
.join-form {
  .disabled {
    color: #777777;
    cursor: not-allowed;
  }
  .checkbox input[type="checkbox"] {
    width: auto;
  }

  label {
    // color: #000080;
    font-size: 1.1em;
    width: auto;
  }

  h4 {
    font-size: 1.5em;
    border-bottom: 1px solid #000080;
    color: #000080;
    margin: 15px 0px;
  }

  .lvl_1 {
    margin-top: 10px;
    .lvl_3 {
      padding-left: 20px;
      > div > .lbl {
        display: block;
        padding: 15px 0 10px 10px;
        font-size: 18px;
        color: #11a8a8;
      }
    }
  }

  .lvl_1 .title {
    color: #fff;
    background: #fa8100;
    padding: 8px 12px 4px 12px;
    font-size: 1.3em;
    line-height: 1.3em;
  }

  .lvl_2 .title {
    color: #000080;
    padding: 8px 12px 4px 12px;
    margin: 20px 0px 0px 0px;
    font-size: 1.2em;
    line-height: 1.2em;
    background: #d0f0f0;
  }

  //   .tips {
  //     margin: -10px 0px 0px 0px;
  //     font-size: 0.9em;
  //     color: #990000;
  //     padding-left: 8px;
  //   }

  /*.lvl_1{
      margin-left: 10px;
    }*/
  .lvl_2 {
    padding-left: 20px;
    .checkbox .tips {
      padding-left: 10px;
    }
  }
  .lvl_3 {
    padding-left: 40px;
  }
  /*.game-group .title{
      font-size: 23px;
    }*/
  .error {
    color: red;
  }
  .footer label {
    padding-left: 0;
    margin-left: 20px;
  }

  table {
    background-color: #f7f7f7;
    border: 1px solid #ccc;
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    table-layout: fixed;
    width: 100%;
  }

  table tr {
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    padding: 0.35em;
  }

  table th,
  table td {
    min-height: 100px;
    padding: 0.625em;
    text-align: center;
  }

  /*刪除按鈕*/
  .remove-one a {
    color: #aaa;
  }

  .preview {
    //預覽
    .tips {
      padding-left: 0;
    }
    .lvl_1 .title {
      background: none;
      color: #fa8100;
    }
    .lvl_2 {
      margin-left: 10px;
      label {
        margin-left: 0;
      }
      .checkbox {
        margin-left: 20px;
      }
    }
    .lvl_2,
    .lvl_3,
    .lvl_2 .title {
      display: inline-block;
    }
    .lvl_3 {
      padding-left: 0;
      label {
        margin-left: 0;
        padding-left: 0;
      }
    }
    .lbl,
    .lvl_2 .title {
      color: #000;
      position: relative;
      &:before {
        content: " ";
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -2.5px;
        margin-left: -15px;
        display: inline-block;
        width: 5px;
        height: 5px;
        background: #000;
        border-radius: 50%;
      }
    }
    .lvl_2 .title {
      background: none;
      &:before {
        margin-left: 0;
      }
      &:after {
        content: ":";
        position: absolute;
        display: inline-block;
        top: 50%;
        margin-top: -8px;
        right: 3px;
      }
    }
    .lvl_3 .lbl:before {
      content: none;
    }
  }
}
.pi-game-vue {
  .sportTable {
    .invalid-feedback {
      background-color: #f7f7ff;
    }
  }

  input,
  textarea {
    border: 1px solid #ccc;
  }
  input {
    padding: 10px;
    width: 100%;
    font-size: 1rem;
    border: 1px solid #ccc;
    color: #000;
    vertical-align: middle;
    box-sizing: border-box;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    padding: 10px;
    width: 100%;
    background-color: #fff;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
    color: #000;
  }
}
</style>
